import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { SettingService } from 'src/app/core/service/setting.service';
import { EventListService } from 'src/app/core/service/grid-data/grid-data-event.service';
import { EventData } from 'src/app/event/model/event';
import { Subscription } from 'rxjs';
import { AuthenticationService } from 'src/app/core/authentication/authentication.service';
import { FilterService } from 'src/app/core/filter/filter.service';
import { Filter } from 'src/app/core/filter/filter';
import { State } from '@progress/kendo-data-query';
import { ActivatedRoute } from '@angular/router';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';

@Component({
  standalone: false,
  selector: 'app-dashboard-coordinator-top-center',
  templateUrl: './dashboard-coordinator-top-center.component.html',
  styleUrls: ['./dashboard-coordinator-top-center.component.scss']
})
export class DashboardCoordinatorTopCenterComponent implements OnInit, OnDestroy
{
  @ViewChild(TooltipDirective) public tooltipDir: TooltipDirective;

  public limitEventsHours = 0;
  public limitEventsText = {};
  public existEvents = false;
  public pieData: any[] = [];
  public topCenterLoading = true;

  private currentUser = this.authenticationService.currentUser;
  private eventSummary: Map<string, number>;
  private routeParamSubscription: Subscription;
  private listSubscription: Subscription;
  private dateLimit: Date;
  private state: State = {
    skip: 0,
    // Initial filter descriptor
    filter: {
      logic: 'and',
      filters: []
    }
  };

  constructor(
    private settingService: SettingService,
    private route: ActivatedRoute,
    private eventListService: EventListService,
    private authenticationService: AuthenticationService,
    private filterService: FilterService,
    private translate: TranslateService
  )
  {
    this.labelContent = this.labelContent.bind(this);
  }

  public ngOnInit(): void
  {
    this.eventSummary = new Map<string, number>();
    this.resetSummary();

    this.settingService.getCachedSessionSettings().subscribe({
      next: (sessionSetting) =>
      {
        this.limitEventsHours = sessionSetting.noticeEventsHoursFilter !== undefined ?
          sessionSetting.noticeEventsHoursFilter : 24;

        // Get the translation used when file types is invalid
        this.translate.get(['CLINICAL-EVENTS-LIMIT']).subscribe({
          next: (res) =>
          {
            this.limitEventsText = res['CLINICAL-EVENTS-LIMIT'].replace('{{limitEvents}}', this.limitEventsHours);
          }
        });
        this.topCenterLoading = false;
      }
    });

    this.listSubscription = this.eventListService.subscribe({
      next: (values: EventData) =>
      {
        if (values !== null)
        {
          this.resetSummary();
          values.data.forEach(d =>
          {
            if (d.eventType === 'ADMISSION')
            {
              this.eventSummary.set('Admission', this.eventSummary.get('Admission') + 1);
              this.existEvents = true;
            }
            else if (d.eventType === 'DISCHARGE')
            {
              this.eventSummary.set('Discharge', this.eventSummary.get('Discharge') + 1);
              this.existEvents = true;
            }
            else if (d.eventType === 'FACILITY_TRANSFER')
            {
              this.eventSummary.set('Transfer', this.eventSummary.get('Transfer') + 1);
              this.existEvents = true;
            }
            else
            {
              this.eventSummary.set('Others', this.eventSummary.get('Others') + 1);
              this.existEvents = true;
            }
          });
          this.pieData = [];
          this.eventSummary.forEach((value: number, key: string) =>
          {
            const pieData: any = {};
            pieData.category = key;
            pieData.value = value;
            this.pieData.push(pieData);
          });
        }
      }
    });

    this.routeParamSubscription = this.route.params.subscribe({
      next: () =>
      {
        this.getEvents();
      }
    });
  }

  public ngOnDestroy(): void
  {
    if (this.routeParamSubscription !== undefined) { this.routeParamSubscription.unsubscribe(); }
    if (this.listSubscription !== undefined) { this.listSubscription.unsubscribe(); }
  }

  public labelContent(e: any): string
  {
    return e.category + ': ' + e.value;
  }

  public showTooltip(e: ElementRef): void
  {
    this.tooltipDir.toggle(e, true);
  }
  
  public hideTooltip(): void
  {
    this.tooltipDir.hide();
  }

  private resetSummary(): void
  {
    this.eventSummary.set('Admission', 0);
    this.eventSummary.set('Discharge', 0);
    this.eventSummary.set('Transfer', 0);
    this.eventSummary.set('Others', 0);
  }

  private getEvents()
  {
    this.dateLimit = new Date();
    this.dateLimit.setHours(this.dateLimit.getHours() - this.limitEventsHours);
    this.state = {
      filter: {
        filters: [
          { field: 'user', operator: 'eq', value: this.currentUser.userName },
          { field: 'eventDateTime', operator: 'gte', value: this.dateLimit }
        ], logic: 'and'
      }, group: [], skip: 0, sort: [], take: 99999
    };
    this.getFilterScreen();
  }

  private getFilterScreen()
  {
    const screen = 'COORDINATOR_DASHBOARD';
    this.filterService.getFilterByScreen('Event', screen).subscribe({
      next: (data: Filter) =>
      {
        if (data !== null)
        {
          const filterState = JSON.parse(data.state);
          if (filterState !== null)
          {
            filterState.filter.filters.forEach(f => this.state.filter.filters.push(f));
          }
        }
        this.eventListService.queryByStateAndSource(this.state, 'dashboard');
      }
    });
  }
}
